import { useEffect, useState } from "react";
import i18next from "i18next";

import config from "config/config";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import transformContentResponse from "./transformContentResponse";

const LanguageProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const addLanguageContent = async () => {
      try {
        const res = await fetch(
          config.REG_API_BASE_URL +
            "/Tenants/4D5FFA59-1817-4592-9CEF-E67A65C7B280",
          {
            headers: {
              ClientSecret: config.PORTAL_CLIENT_SECRET,
            },
          }
        );

        if (res.status !== 200) {
          setHasError(true);
        }

        if (res.status === 200) {
          const response = await res.json();

          const content = transformContentResponse(response);

          i18next.addResourceBundle("en", "portals", content);
          i18next.setDefaultNamespace("portals");

          setIsLoading(false);
        }
      } catch (error) {
        setHasError(true);
      }
    };

    if (config.ENABLE_CONFIG_CONTENT === "true") {
      addLanguageContent();
    } else {
      setIsLoading(false);
    }
  }, []);

  if (hasError) {
    throw Error("Error occurred while loading the config API");
  }

  return isLoading ? (
    <EverlakeLoadingOverlay isLoading={isLoading} loadingText="Please wait...">
      <div className="h-screen"></div>
    </EverlakeLoadingOverlay>
  ) : (
    <>{children}</>
  );
};

export default LanguageProvider;
